import axios from 'axios';
import Cookies from 'js-cookie'
import {main_domain} from '@/config/sites'


const API_URL = `${process.env.VUE_APP_ASK_API_URL}/api/`;
const instance = axios.create();
instance.interceptors.request.use(function (config) {
  config.headers["Authorization"] = ''
  return config;
});

class AuthService {

  login(authCode) {
    return instance.post(API_URL + 'auth/signin', 
      {
        code: authCode
      },
    ).then(response => {
        if (response.data.isAuthorized && response.data.accessToken) {
          
          Cookies.set(
            'google_access_token', 
            JSON.stringify(
              {
                "token":`${response.data.accessToken}`,
                "refreshToken":`${response.data.refreshToken}`,
                "role":"admin",
                "area":"agf",
                "source":"google",
                "validate_agenzie": `${response.data.user[0].validate_agenzie ?? ''}`,
                "swo_recovery": response.data.user[0].swo_recovery,
                "can_access_ask_technology": response.data.user[0].can_access_ask_technology
              }
            ),
            { domain: `${main_domain.cookie}`,
              expires: 1 // 1 day
            }
          )

          localStorage.setItem('user', btoa(JSON.stringify(response.data)));
          return response.data;
        }   
      }).catch((err) => {
        console.log(err)
        return 503
      });
  }

  logout() {
    localStorage.removeItem('user');
    Cookies.remove('google_access_token')
  }

  // register(user) {
  //   return axios.post(API_URL + 'signup', {
  //     username: user.username,
  //     email: user.email,
  //     password: user.password
  //   });
  // }
}

export default new AuthService();
